import { Message } from 'element-ui'

const changePxToRem = (num) => {
  return 7.5 / 1080 * num
}

const getScreenStyle = (item) => {
  let str = ''
  str += 'top:' + changePxToRem(item.top) + 'rem;'
  str += 'left:' + changePxToRem(item.left) + 'rem;'
  if (item.fontSize) str += 'font-size:' + changePxToRem(item.fontSize) + 'rem;'
  if (item.color) str += 'color:' + item.color
  return str
}

const getAutoStyle = (data) => {
  if (data.type === 'autoMedia') {
    let str = ''
    if (data.top) str += 'top:' + changePxToRem(data.top) + 'rem;'
    if (data.left) str += 'left:' + changePxToRem(data.left) + 'rem;'
    if (data.width) str += 'width:' + changePxToRem(data.width) + 'rem;'
    if (data.height) str += 'height:' + changePxToRem(data.height) + 'rem;'
    return str
  } else {
    return ''
  }
}

export const getHtmlStr = ({ formList, functionList, selectFunc }) => {
  let domStr = `<!DOCTYPE html>
      <html lang="en">
      <head>
      <meta charset="UTF-8">
      <title>H5广告</title>
      <meta name="viewport" content="width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no,initial-scale=1,viewport-fit=cover">
      <meta name="format-detection" content="telephone=no">
      <meta name="apple-mobile-web-app-status-bar-style" content="white">
      <meta name="apple-mobile-web-app-capable" content="no">
      <style>
        html {
          height: 100%;
        }
        body {
          height: 100%;
          margin: 0;
          padding: 0;
        }
        img {
          vertical-align: bottom;
        }
        #container {
          height: 100%;
          position: relative;
        }
        .ad_video {
          width: 100%;
          height: 50%;
        }
        .video_el {
          width: 100%;
          height: 100%;
        }
        .video_full {
          width: 100%;
          height: 100%;
          vertical-align: bottom;
          object-fit: fill;
        }
        .ad_img {
          width: 100%;
          height: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .ad_img > * {
          flex: 1;
        }
        .img_el {
          float: left;
          width: 33.33%;
        }
        .img_full {
          display: inline-block;
          height: 100%;
          width: 100%;
          vertical-align: bottom;
        }
        .data_count{
          position: absolute;
          text-align: center;
          line-height: 1.2;
        }
        .auto_media{
          position: absolute;
          object-fit: fill;
          vertical-align: bottom;
        }


        /*css 初始化 */
/*!*滚动条初始化*!*/
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  opacity: 0.2;
}
::-webkit-scrollbar-track-piece {
  -webkit-border-radius: 10px;
  opacity: 0.2;
}
::-webkit-scrollbar-thumb:vertical {
  height: 4px;
  background-color: #d3d4d5;
  -webkit-border-radius: 10px;
}
::-webkit-scrollbar-thumb:vertical:hover {
  background-color: #a2a3a5;
}
::-webkit-scrollbar-thumb:horizontal {
  width: 6px;
  background-color: #d3d4d5;
  -webkit-border-radius: 10px;
}
::-webkit-scrollbar-thumb:horizontal:hover {
  background-color: #a2a3a5;
}

html, body {
  height: 100%;
  -webkit-overflow-scrolling: touch;
}

html, body, ul, li, ol, dl, dd, dt, p, h1, h2, h3, h4, h5, h6, form, fieldset, legend, img {
  margin: 0;
  padding: 0;
}

* {
  -webkit-appearance: none; /* 移除iphone/ipad下输入框默认内阴影 */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* iOS和android下触摸元素时出现半透明灰色遮罩(transparent在android下无效) */
  -webkit-touch-callout: none; /* 解决长时间按住页面出现闪退问题 */
  -webkit-user-select: none; /* 禁止复制、选中文本 */
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

fieldset, img {
  border: none;
  padding: 0;
  margin: 0;
  outline-style: none;
}

ul, ol {
  list-style: none;
}

input {
  padding-top: 0;
  padding-bottom: 0;
}

select, input, textarea {
  margin: 0;
}

/*防止拖动*/

textarea {
  resize: none;
}

/*  去掉图片低测默认的3像素空白缝隙*/

img {
  border: 0;
}

table {
  border-collapse: collapse;
}

body {
  height: 100%;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "\\5FAE\\8F6F\\96C5\\9ED1", Arial, sans-serif;
  font-size: 12px;
  line-height: 1.5;
  color: #495060;
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.clearfix:before, .clearfix:after {
  content: "";
  display: block;
}

.clearfix:after {
  clear: both;
}

a {
  color: #666;
  text-decoration: none;
}

h1, h2, h3, h4, h5, h6 {
  text-decoration: none;
  font-weight: normal;
  font-size: 100%;
}

s, i, em {
  font-style: normal;
  text-decoration: none;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.cl {
  clear: both;
}

input, textarea, keygen, select, button {
  font-family: "Hiragino Sans GB", "Microsoft Yahei", SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
  outline: none;
}

.iconfont {
  font-size: 14px;
}



      </style>
      </head>
      <body><div id="container">`
  const count = formList.length
  if (count === 1) {
    const only = formList[0]
    if (only.required && !only.reourceAddress) {
      Message.warning(only.name + '未填写，请填写后在保存')
      return
    }
    if (only.type === 'fullImg') {
      domStr += `<img class="img_full" src="${only.reourceAddress}" alt="${only.name}"></div>`
    } else if (only.type === 'fullVideo') {
      domStr += `<video class="video_full" autoplay loop src="${only.reourceAddress}"></video>`
    }
  } else {
    for (let i = 0; i < formList.length; i++) {
      const temp = formList[i]
      if (temp.required && !temp.reourceAddress) {
        Message.warning(temp.name + '未填写，请填写后在保存')
        return
      }
      if (temp.type === 'video') {
        domStr += `<div class="ad_video"><video class="video_el" autoplay loop src="${temp.reourceAddress}"></video></div>`
      } else if (temp.type === 'img') {
        if (i === 1) domStr += `<div class="ad_img">`
        domStr += `<img class="img_el" src="${temp.reourceAddress}" alt="${temp.name}">`
        if (i === formList.length - 1) domStr += '</div>'
      } else if (temp.type === 'autoMedia') {
        if (temp.reourceAddress) {
          if (temp.sourceType === 'img') {
            domStr += `<img class="auto_media" style="${getAutoStyle(temp)}" src="${temp.reourceAddress}" alt="${temp.name}">`
          } else if (temp.sourceType === 'video') {
            domStr += `<video class="auto_media" style="${getAutoStyle(temp)}" autoplay loop src="${temp.reourceAddress}"></video>`
          }
        }
      }
    }
  }
  functionList.forEach(item => {
    if (selectFunc[item.type]) {
      if (item.type === 'dateCount') {
        const countObj = item
        domStr += `<div class="data_count" style="${getScreenStyle(countObj)}">`
        domStr += `<p style="margin-bottom: ${changePxToRem(countObj.marginBottom)}rem" id="dateCountDay"></p>`
        domStr += `<p style="margin-bottom: ${changePxToRem(countObj.marginBottom)}rem" id="dateCountHour"></p>`
        domStr += `<p style="margin-bottom: ${changePxToRem(countObj.marginBottom)}rem" id="dateCountMinute"></p>
            <p id="dateCountSecond"></p>
          </div>`
        domStr += '<script>'
        domStr += `var timeInterval = null
                  var endDate = '${countObj.endTime}'
                  function start () {
                    if (timeInterval) {
                      clearInterval(timeInterval)
                    }
                    timeInterval = setInterval(dateCount, 1000)
                  }
                  function dateCount () {
                    var timeRange = (+new Date(endDate) - new Date())
                    var d, h, m, s
                    if (timeRange >= 0) {
                      d = Math.floor(timeRange / 1000 / 60 / 60 / 24)
                      h = Math.floor(timeRange / 1000 / 60 / 60 % 24)
                      m = Math.floor(timeRange / 1000 / 60 % 60)
                      s = Math.floor(timeRange / 1000 % 60)
                    } else {
                      d = 0
                      h = 0
                      m = 0
                      s = 0
                    }
                    document.getElementById('dateCountDay').innerText=d
                    document.getElementById('dateCountHour').innerText=h
                    document.getElementById('dateCountMinute').innerText=m
                    document.getElementById('dateCountSecond').innerText=s
                  }
                  start()`
        domStr += '</' + 'script>'
      } else if (item.type === 'bgMusic') {
        domStr += `<audio controls="controls" style="display: none" src="${item.reourceAddress}" loop autoplay></audio>`
      }
    }
  })
  domStr += `</div>`
  domStr += '<script>'
  domStr += `(function(doc, win) {
      var docEl = doc.documentElement,
          isIOS = navigator.userAgent.match(/\\(i[^;]+;( U;)? CPU.+Mac OS X/),
          dpr = isIOS ? Math.min(win.devicePixelRatio, 3) : 1,
          dpr = window.top === window.self ? dpr : 1, //被iframe引用时，禁止缩放
          dpr = 1,
          scale = 1 / dpr,
          resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
      docEl.dataset.dpr = dpr;
      var metaEl = doc.createElement('meta');
      metaEl.name = 'viewport';
      metaEl.content = 'initial-scale=' + scale + ',maximum-scale=' + scale + ', minimum-scale=' + scale;
      docEl.firstElementChild.appendChild(metaEl);
      var recalc = function() {
          var width = docEl.clientWidth;
          docEl.style.fontSize = 100 * (width / 750) + 'px';
      };
      recalc()
      if (!doc.addEventListener) return;
      win.addEventListener(resizeEvt, recalc, false);
  })(document, window);
`
  domStr += '</script>'
  domStr += `</div></body></html>`
  return domStr
}
